import React, { useEffect, useState } from "react";
import { FaSave, FaSpinner } from "react-icons/fa";
import Toast from "../../components/Toast/Toast";
import { getBankDetailsAPI, updateBankDetailsAPI } from "../../utils/api";
import "./BankDetails.css";
import { getErrorMessage } from "../../constants/globalFunction";

const BankDetails = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [toast, setToast] = useState({ show: false, message: "", type: "" });

    const [bankName, setBankName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [branch, setBranch] = useState("");
    const [upi, setUpi] = useState("");

    const showToast = (message, type = "success") => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: "", type: "" }), 3000);
    };

    // Fetch bank details
    const fetchBankDetails = async () => {
        try {
            const response = await getBankDetailsAPI();

            if (response?.status === 200 && response?.data) {
                const bankData = response.data;
                setBankName(bankData?.bank_name || "");
                setAccountNumber(bankData?.account_number || "");
                setIfscCode(bankData?.ifsc_code || "");
                setBranch(bankData?.branch || "");
                setUpi(bankData?.upi || "");
            }
        } catch (err) {
            console.error('Fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchBankDetails();
    }, []);

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setSaving(true);

            // Basic validation
            if (!bankName.trim()) {
                showToast('Bank name is required', 'error');
                return;
            }

            if (!accountNumber.trim()) {
                showToast('Account number is required', 'error');
                return;
            }

            if (!ifscCode.trim()) {
                showToast('IFSC code is required', 'error');
                return;
            }

            if (!branch.trim()) {
                showToast('Branch is required', 'error');
                return;
            }
            const userId = localStorage.getItem('userId');

            const updateData = {
                bank_name: bankName.trim(),
                account_number: accountNumber.trim(),
                ifsc_code: ifscCode.trim(),
                branch: branch.trim(),
                upi: upi.trim() || null,
                user_id: userId
            };

            const response = await updateBankDetailsAPI(updateData);

            if (response?.status === 200) {
                fetchBankDetails();
                showToast('Bank details updated successfully', 'success');
            } else if (response?.message) {
                showToast(getErrorMessage(response?.message), "error");
            } else {
                showToast('Failed to update bank details', "error");
            }
        } catch (err) {
            console.error('Update error:', err);
            showToast('Failed to update bank details', "error");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <>
                <Toast toast={toast} />
                <div className="BankDetails-container">
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading bank details...</p>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Toast toast={toast} />

            <div className="BankDetails-container">
                <div className="BankDetails-cards-container">
                    {/* Bank Details Card */}
                    <div className="BankDetails-card">
                        <div className="BankDetails-card-content">
                            <form onSubmit={handleSubmit} className="BankDetails-form">
                                <div className="BankDetails-form-grid">
                                    <div className="BankDetails-field-group">
                                        <label className="BankDetails-field-label required">Bank Name</label>
                                        <input
                                            type="text"
                                            value={bankName}
                                            onChange={(e) => setBankName(e.target.value)}
                                            className="BankDetails-input"
                                            placeholder="Enter bank name"
                                            required
                                        />
                                    </div>

                                    <div className="BankDetails-field-group">
                                        <label className="BankDetails-field-label required">Account Number</label>
                                        <input
                                            type="text"
                                            value={accountNumber}
                                            onChange={(e) => setAccountNumber(e.target.value)}
                                            className="BankDetails-input"
                                            placeholder="Enter account number"
                                            required
                                        />
                                    </div>

                                    <div className="BankDetails-field-group">
                                        <label className="BankDetails-field-label required">IFSC Code</label>
                                        <input
                                            type="text"
                                            value={ifscCode}
                                            onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
                                            className="BankDetails-input"
                                            placeholder="Enter IFSC code"
                                            required
                                        />
                                    </div>

                                    <div className="BankDetails-field-group">
                                        <label className="BankDetails-field-label required">Branch</label>
                                        <input
                                            type="text"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                            className="BankDetails-input"
                                            placeholder="Enter branch name"
                                            required
                                        />
                                    </div>

                                    <div className="BankDetails-field-group">
                                        <label className="BankDetails-field-label">UPI ID</label>
                                        <input
                                            type="text"
                                            value={upi}
                                            onChange={(e) => setUpi(e.target.value)}
                                            className="BankDetails-input"
                                            placeholder="Enter UPI ID (e.g., name@bank)"
                                        />
                                    </div>
                                </div>

                                <div className="BankDetails-actions">
                                    <button
                                        type="submit"
                                        disabled={saving}
                                        className="BankDetails-save-btn"
                                    >
                                        {saving ? (
                                            <>
                                                Saving...
                                            </>
                                        ) : (
                                            <>
                                                Save
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BankDetails;
